import { uniq, unionBy } from '../dependencies';
import types from './actionTypes';

const initialState = {
    data: [],
    triedToFetch: [],
    fetchingMenusIds: [],
};

export default function(state = initialState, { type, payload }) {
    switch (type) {
        case types.REQUEST_MENUS:
            return {
                ...state,
                fetchingMenusIds: payload.ids,
            };

        case types.REQUEST_MENUS_COMPLETED:
            return {
                ...state,
                fetchingMenusIds: [],
                triedToFetch: uniq(state.triedToFetch.concat(state.fetchingMenusIds)),
            };

        case types.SET_MENUS:
            return {
                ...state,
                data: unionBy(payload.menus, state.data, 'id'),
            };

        default:
            return state;
    }
}
